import { lazy, Suspense } from "react";
import { render } from "react-dom";
import "@pacificoseguros/pixie/variables.css";
import "reflect-metadata";

import { register, unregister } from "src/sw-manager";
import { setupContainer } from "src/infra/di/setup";
import jscookie from "js-cookie";
import "src/assets/styles/index.css";
import "src/assets/styles/v1.scss";
import "src/assets/styles/theme/theme.scss";

declare global {
    interface Window {
        dynatraceParams?: {
            userIdentifier?: string;
        };
        userIdentity: string;
        redirectToNewHome: (route?: string) => void;
        redirectToPaymentsAfterPay: (hash: string) => void;
        MobileNavigateToFlutterView?: MessagePort;
        fbq?: (action: string, event: string, params?: any) => void;
    }
}

setupContainer();

const queryParams = new URLSearchParams(window.location.search);
// Indica que se está ejecutando dentro de un iframe
const isRunningEmbedded =
    queryParams.get("origin") === "flutterWeb" ||
    jscookie.get("origin") === "flutterWeb";

/**
 * Si la web está embebida en un iframe,
 * eliminamos las cookies cada vez que se monta
 */
if (isRunningEmbedded) {
    jscookie.remove("auth-token-client");
    jscookie.remove("auth-data-client");
}

// we want to load it as a chunk to avoid waterfall
import(/*webpackChunkName: "pixie"*/ "./libs/pixie").then((module) =>
    module.usePixie()
);

// we want to load it as a chunk to avoid waterfall
const App = lazy(
    () => import(/*webpackChunkName: "app"*/ "./containers/app/app")
);

function hasOnboardingError() {
    const onboardingParams = new URLSearchParams(window.location.hash);
    const tokenCodeExpired =
        process.env.REACT_APP_ONBOARDING_EXPIRED_TOKEN_CODE ?? "";

    if (onboardingParams.has("error_description")) {
        const errorDescription = onboardingParams.get("error_description");
        if (errorDescription && errorDescription.startsWith(tokenCodeExpired)) {
            setTimeout(() => {
                window.location.href = "/expired_token.html";
            }, 1);
            return true;
        }
        setTimeout(() => {
            window.location.href = "/malformed_url.html";
        }, 1);
        return true;
    }
    return false;
}

if (!hasOnboardingError()) {
    window.dynatraceParams = {};

    render(
        <Suspense fallback={<div />}>
            <App />
        </Suspense>,
        document.getElementById("root")
    );
}

/* always disable sw on desktop */
if (
    matchMedia("(min-width: 1025px)").matches ||
    window.location.search.includes("origin=flutterWeb")
) {
    unregister();
} else {
    register();
}
